import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Tab, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyEventsCategory } from './../../../actions';

import './categoryexplorer.scss';

class CategoryExplorer extends React.Component {

  constructor(props) {
    super(props);

    this.handleOnSelectCategory = this.handleOnSelectCategory.bind(this);
  }

  /* Handlers */
  handleOnSelectCategory(activeKey) {
    this.props.actions.customerJourneyEventsCategory(activeKey, this.props.token, this.props.currentLanguage, this.props.context);
    this.props.onChangeCurrentCategoryId(activeKey);
  }

  render() {

    let navItems = [];
    let menuItems = [];

    if(this.props.eventsCategories.apiData.length > 0) {
      this.props.eventsCategories.apiData.forEach((eventsCategory, index) => {
        const categoryLabel = <span><img width={16} height={16} src={eventsCategory.picture} alt={eventsCategory.name}/> {eventsCategory.name.toUpperCase()}</span>;
        navItems.push(<NavItem className="hidden-xs hidden-sm" key={index} eventKey={eventsCategory.id}>{categoryLabel}</NavItem>);
        menuItems.push(<MenuItem key={index} eventKey={eventsCategory.id}>{categoryLabel}</MenuItem>);
      });
    }
    else {
      navItems.push(<NavItem key={0} className="hidden-xs hidden-sm" eventKey="loading" disabled><i className="fa fa-ellipsis-h fa-fw"></i></NavItem>);
      menuItems.push(<MenuItem key={0} className="hidden-xs hidden-sm" eventKey="loading"><i className="fa fa-ellipsis-h fa-fw"></i></MenuItem>)
    }

    return (
      <Tab.Container id="events-category-tabs" activeKey={this.props.currentCategoryId} onSelect={this.handleOnSelectCategory} className="events-categoryexplorer-component">
        <Row className="clearfix">
          <Col xs={12}>
            <Nav bsStyle="tabs">
              {navItems}
              <NavDropdown className="hidden-md hidden-lg" eventKey="collapsed" title={this.props.translate('events.category_explorer.categories')}>
                {menuItems}
              </NavDropdown>
            </Nav>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}

CategoryExplorer.displayName = 'PagesEventsCategoryExplorer';
CategoryExplorer.propTypes = {};
CategoryExplorer.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      eventsCategories: state.eventsCategories,
      eventsCategory: state.eventsCategory
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyEventsCategory: bindActionCreators(customerJourneyEventsCategory, dispatch),
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryExplorer);



// WEBPACK FOOTER //
// ./components/pages/events/CategoryExplorer.js